import React, { useContext } from 'react';
import Stack from '@mui/material/Stack/Stack';
import { OrderSection } from '../../OrderSection';
import { errorStates, inProcessingState, Order, Shipment } from '../../../../../../Models';
import { ShipmentsContext } from '../../../../../../services/Deliveries';
import ShipmentTimeline from './ShipmentTimeline';
import ShipmentDetails from './ShipmentDetails';
import SummaryRow from './SummaryRow';
import { ToPreviousStateButton } from '../../EditableOfferCard/ToPreviousStateButton';
import { ReScheduleStock } from '../../EditableOfferCard/ReScheduleStock';

function SummaryCard({ order }: { order: Order }) {
    const { shipments } = useContext(ShipmentsContext);
    const shipment: Shipment | undefined = shipments[order.delivery_id || ''];
    let rescheduleDisabled = true;
    if (['assigned', 'validated'].includes(order.state)) {
        rescheduleDisabled = false;
    } else if (order.state === 'fulfilled') {
        rescheduleDisabled = true;
    }
    if ([...errorStates, 'estimated'].includes(shipment?.state)) {
        rescheduleDisabled = false;
    }
    const toPreviousDisabled = !['assigned', 'validated'].includes(order.state);
    return (
        <OrderSection>
            <Stack direction="column" spacing={2}>
                <SummaryRow order={order} />
                {(inProcessingState(order) || order.state === 'fulfilled') && (
                    <Stack direction="column" spacing={2}>
                        <ShipmentDetails shipment={shipment} />
                        <ShipmentTimeline shipment={shipment} order={order} />
                    </Stack>
                )}
                {!['emitted', 'fulfilled'].includes(order.state) && (
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                        mt={1}>
                        <ToPreviousStateButton order={order} disabled={toPreviousDisabled} />
                        <ReScheduleStock order={order} disabled={rescheduleDisabled} />
                    </Stack>
                )}
            </Stack>
        </OrderSection>
    );
}

export default SummaryCard;
